import React, {Component} from 'react';

export default class Resume extends Component {
    constructor(props) {
        super(props);
        this.state = this.props;
    }
    render() {
        return (
            <div className='ResumeDiv'>
                {
                    !this.props.data.stylesheet?'':
                        <link rel="stylesheet" type="text/css" href={this.props.data.stylesheet} />
                }
                <ResumeHeader name={this.state.data.name} contact={this.state.data.contact}/>
                {
                    !this.state.data.sections?'':
                    <div className='ResumeSectionBox'>
                        {this.state.data.sections.map((section,i)=>
                        <ResumeSection key={i} title={section.name} type={section.type} list={section.members}/>)}
                    </div>
                }
            </div>
        );
    }
}

class ResumeHeader extends Component {
    render() {
        return (
            <div className="ResumeHeader">
                <h1 className='ResumeHeaderName'>{this.props.name}</h1>
                <ResumeContactInfo contact={this.props.contact}/>
            </div>
        );
    }
}

class ResumeContactInfo extends Component {
    constructor(props){
        super(props);
        this.state = {props: {
            contact: props.contact,
            hidden: false,
            props: null,
        }};
        this.state.hidden = true;
    }

    testFunc(asd){
        return <div>{asd}</div>
    }

    render() {
        return (
            <div className='ResumeContactInfo'>
                {

                    (this.state.props) ?
                    <button onClick={function(){this.setState(this.state.props);}.bind(this)}>Show Contact Info</button>:
                    <p className='ResumeContactInfoContent'>
                    {
                        !this.state.contact?'':
                        this.state.contact.map((citem,i)=>{
                            return <span className={'ResumeContactItem'+(!citem.type?'':' '+citem.type)} key={i} data-label={!citem.label?'':citem.label}>
                            {
                                (()=>{
                                    switch(citem.type){
                                        case 'email':
                                            return <a href={'mailto://'+citem.content}>{citem.content}</a>;
                                        case 'link':
                                            return <a href={'//'+citem.content}>{citem.content}</a>;
                                        default:
                                            return citem.content;
                                    }
                                })()
                            }
                            </span>
                        })
                    }
                    </p>
                }
                
            </div>
        )
    }
}

class ResumeSection extends Component {
    render() {
        return (
            <div className={'ResumeSection'+(!this.props.title?'':' '+this.props.title)}>
                {
                    this.props.title&&
                        <p className='ResumeSectionHeader'>{this.props.title}</p>
                }
                <div className='ResumeSectionItemList'>
                {
                    !this.props.list?'':this.props.list.map((sec,i)=>{
                    switch(this.props.type){
                        case 'skills':
                            return <ResumeSkills data={sec} key={i}/>
                        default:
                            return <ResumeSectionItem type={this.props.type} data={sec} key={i}/>
                    }
                })}
                </div>
            </div>
        );
    }
}

class ResumeSectionItem extends Component {
    render() {
        return (
            <div className='ResumeSectionItem'>
                <span className='ResumeSectionItemTitle'>{this.props.data.title}</span>
                <span className='ResumeSectionLocation'>
                    {
                        !this.props.data.locationSet?'':
                            this.props.data.locationSet.map((loc,i)=>{
                                return <span className='ResumeLocationItem' key={i}>
                                     {!(this.props.data.title||i>0)?'':<span className='ResumeLocationComma'>, </span>}{loc}
                                </span>;
                            })
                    }
                </span>
                {
                    !this.props.data.items?'':
                        this.props.data.items.map((item,i)=>{
                            switch(item.type){
                                case 'position':
                                    return <ResumePosition data={item.data} key={i}/>
                                case 'labeledList':
                                    return <ResumeLabeledList data={item.data} key={i}/>
                                case 'text':
                                    return <ResumeText data={item.data} key={i}/>
                                default:
                                    return '';
                            }
                        })
                }
            </div>
        );
    }
}

class ResumePosition extends Component {
    render() {
        return (
            <div className='ResumePosition'>
                {
                    !this.props.data.title?'':
                    <span className='ResumePositionTitle'>{this.props.data.title}</span>
                }
                <span className='ResumePositionDate'>
                    {
                        !this.props.data.dateSet?'':
                            this.props.data.dateSet.map((date,i)=>{ //refactor this later
                                if(typeof(date)==='string'){
                                    return <span className='ResumeDateItem' key={i}>{!(this.props.data.title||i>0)?'':<span className='ResumePositionDateComma'>, </span>}{date}</span>
                                }
                                else if(typeof(date)==='object'&&date[0]&&date[1]){
                                    return <span className='ResumeDateItem' key={i}>{!(this.props.data.title||i>0)?'':<span className='ResumePositionDateComma'>, </span>}
                                    {date[0]}<span className='ResumePositionDateDash'> - </span>{date[1]}</span>;
                                }
                                else{
                                    return '';
                                }
                            })
                    }
                </span>
                    {
                        !this.props.data.responsibilities?'':
                            <ul>{this.props.data.responsibilities.map((resp,i)=><li key={i}>{resp}</li>)}</ul>
                    }
            </div>
        );
    }
}

class ResumeSkills extends Component {
    render() {
        return (
            <div className='ResumePosition'>
                <ul>
                    {
                        this.props.data.map((skill,i)=><li key={i}>{skill.name}{skill.proficiency?' - '+skill.proficiency:''}</li>)
                    }
                </ul>
            </div>
        );
    }
}

class ResumeLabeledList extends Component {
    render() {
        return (
            <div className='ResumeLabeledList'>
                <div className='ResumeLabeledListName'>{this.props.data.name?this.props.data.name+':':''}</div>
                <ul>
                    {
                        !this.props.data.items?'':
                            this.props.data.items.map((item,i)=><li key={i}>{item}</li>)
                    }
                </ul>
            </div>
        );
    }
}

class ResumeText extends Component {
    render() {
        return (
            <p className='ResumeText'>
                {
                    this.props.data&&
                        this.props.data.map((text,i)=>{
                            return <span className={'ResumeTextItem i'+i} key={i}>{text}</span>;
                        })
                }
            </p>
        );
    }
}




// WEBPACK FOOTER //
// ./src/Resume.js